import { render } from "./VerifyOtpView.vue?vue&type=template&id=4624fe20"
import script from "./VerifyOtpView.vue?vue&type=script&lang=js"
export * from "./VerifyOtpView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__